import { render, staticRenderFns } from "./RoleGroup.vue?vue&type=template&id=663bd8e5&scoped=true&"
import script from "./RoleGroup.vue?vue&type=script&lang=ts&"
export * from "./RoleGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RoleGroup.vue?vue&type=style&index=0&id=663bd8e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bd8e5",
  null
  
)

export default component.exports